export interface FindStoresResponse {
  data?: StoreDetailResponseItem[]
  count: number
}

export interface StoreHours {
  day: string
  open: string
  close: string
  isClosed: boolean
}

export interface StoreDetailResponseItem {
  address1: string
  address2: string
  c_priceBookRegion: string
  c_storeFeatures: {
    displayValue: string
    value: string
  }[]
  c_storeHoursJson: StoreHours[]
  c_storeRegion: string
  city: string
  distance: number
  distanceUnit: string
  id: string
  latitude: number
  longitude: number
  name: string
  phone: string
  posEnabled: boolean
  postalCode: string
  storeHours: string
  storeLocatorEnabled: boolean
  c_displayOnStoreFinder?: boolean
  c_rapidDeliveryEnabledForStore?: boolean
}

export interface SeasonalHours extends StoreHours {
  title: string
  open24HourTime: string
  close24HourTime: string
  validFrom: string
  validTo: string
}

export function isSeasonalHours(item: StoreHours | SeasonalHours): item is SeasonalHours {
  return (item as SeasonalHours).validFrom !== undefined && (item as SeasonalHours).validTo !== undefined && (item as SeasonalHours).title !== undefined
}

export interface SeasonalHoursResponseItem {
  start: string
  end: string
}

